/**
 * To allow Vue components access to this binding, must be a declared funciton
 * Below method cannot be refactored to an arrow function
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/this
 * */

export default function createComputedObjectBinding(field) {
  return {
    get() {
      return this.value[field];
    },
    set(newValue) {
      this.$emit('input', {
        ...this.value,
        [field]: newValue,
      });
    },
  };
}
